import { useStateStore } from '../../stores/useStateStore';

export const useSendChatMessage = () =>
  useStateStore((state) => state.sendChatMessage);

export const useSendChatBackgroundMessage = () =>
  useStateStore((state) => state.sendChatBackgroundMessage);

